/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Nodecreated1Inputs */

const zh_course_nodecreated1 = /** @type {(inputs: Course_Nodecreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节点已添加`)
};

const en_course_nodecreated1 = /** @type {(inputs: Course_Nodecreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Node added`)
};

const es_course_nodecreated1 = /** @type {(inputs: Course_Nodecreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodo añadido`)
};

/**
* | output |
* | --- |
* | "Node added" |
*
* @param {Course_Nodecreated1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_nodecreated1 = /** @type {((inputs?: Course_Nodecreated1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Nodecreated1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_nodecreated1(inputs)
	if (locale === "en") return en_course_nodecreated1(inputs)
	return es_course_nodecreated1(inputs)
});
export { course_nodecreated1 as "course_nodeCreated" }